// @ts-strict-ignore
import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";

import classes from "./style.scss";

interface Props {
	className?: string;
	outerClassName?: string;
	style?: React.CSSProperties;
	children: JSX.Element | JSX.Element[];
}

const PageContainer : React.FC<Props> = ({
	className,
	outerClassName,
	style,
	children
}) => {
	const allClasses = [classes.pageContainer];

	if (className) {
		allClasses.push(className);
	}

	const pageContainerElement = (
		<div
			className={allClasses.join(" ")}
			style={style}
		>
			{children}
		</div>
	);

	if (!outerClassName) {
		return pageContainerElement;
	}

	return (
		<div className={outerClassName}>
			{pageContainerElement}
		</div>
	);
};

export default withStyles(classes)(PageContainer);
